import ClientFeedbackSearchBar from './ClientFeedbackSearchBar';

export default ClientFeedbackSearchBar;
